import { Card, Container } from '@chakra-ui/react'
import { Link } from 'react-router-dom'

import { Button } from '@app/components/ui/button'

const Upgrade = ({ ...rest }) => (
  <Container maxW="lg" {...rest}>
    <Card.Root variant="elevated">
      <Card.Header>
        <Card.Title>Upgrade for access</Card.Title>
      </Card.Header>
      <Card.Body>
        <Card.Description>To add integrations, please upgrade to the Pro plan</Card.Description>
      </Card.Body>
      <Card.Footer justifyContent="flex-end">
        <Button id="intercom-launcher" variant="outline">
          Contact support
        </Button>
        <Button asChild>
          <Link to="/settings/billing">Upgrade</Link>
        </Button>
      </Card.Footer>
    </Card.Root>
  </Container>
)

export default Upgrade
